import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { MessageCircle, Camera, Calendar, Sparkles } from 'lucide-react';
import { t } from '../../lib/i18n';

const primaryClass = 'flex flex-col items-center gap-2 h-auto py-4 bg-lux-gold/10 border border-lux-gold/20 text-[var(--lux-amber)] hover:bg-lux-gold/15 transition-colors duration-200';
const secondaryClass = 'flex flex-col items-center gap-2 h-auto py-4 bg-white/5 border border-white/10 text-white/70 hover:bg-white/8 transition-colors duration-200';

const ActionButton = ({ testId, onClick, icon: Icon, label, primary = false, busy = false, disabled = false }) => (
  <Button data-testid={testId} onClick={onClick} disabled={disabled} className={primary ? primaryClass : secondaryClass} variant="ghost">
    {busy
      ? <div className="w-5 h-5 border-2 border-[var(--lux-gold)] border-t-transparent rounded-full animate-spin" />
      : <Icon className="w-5 h-5" />}
    <span className="text-xs">{label}</span>
  </Button>
);

export const QuickActions = ({ language, onNavigate, onFullAnalysis, analyzing }) => (
  <Card className="bg-lux-panel/90 border-white/[0.08] fade-in" data-testid="dashboard-quick-actions">
    <CardHeader className="pb-3">
      <CardTitle className="text-lg font-display text-white">{t('quickActions', language)}</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <ActionButton testId="dashboard-quick-action-start-chat" onClick={() => onNavigate('/coach')} icon={MessageCircle} label={t('startChat', language)} primary />
        <ActionButton testId="dashboard-quick-action-photo" onClick={() => onNavigate('/simulation')} icon={Camera} label={t('uploadPhoto', language)} />
        <ActionButton testId="dashboard-quick-action-routine" onClick={() => onNavigate('/routine')} icon={Calendar} label={t('generateRoutine', language)} />
        <ActionButton testId="dashboard-quick-action-analysis" onClick={onFullAnalysis} icon={Sparkles} label={t('fullAnalysis', language)} busy={analyzing} disabled={analyzing} />
      </div>
    </CardContent>
  </Card>
);
